import { Injectable } from "@angular/core";
import { RealtimeAttributeResponse } from "../../../models/ws/realtimeAttributes";
import {
  RealtimeSubscriptionHandle,
  RealtimeSubscriptionRequest,
  RealtimeSubscriptionService,
} from "../realtime-subscription.service";

export interface AttributesSubscriptionDescriptor extends RealtimeSubscriptionRequest {
  entityType: string;
  entityId: readonly string[];
  keys: readonly string[];
}

export type AttributesSubscriptionHandle = RealtimeSubscriptionHandle<
  RealtimeAttributeResponse,
  AttributesSubscriptionDescriptor
>;

@Injectable({
  providedIn: "root",
})
export class AttributesWebsocketService extends RealtimeSubscriptionService<
  RealtimeAttributeResponse,
  AttributesSubscriptionDescriptor
> {
  protected readonly PATH = "attributes";
  protected readonly VERSION = 1;
}
